var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SnackbarQueue',{attrs:{"items":_vm.snackbarNotifications,"next-button-count-text":"More","closeButtonIcon":"mdi-close","bottom":"","right":""},on:{"remove":_vm.removeItem}})
}
var staticRenderFns = []

export { render, staticRenderFns }